export default function ChartFilters({ fields = [], entries = [], filters = {}, onChange }) {
  const available = fields.filter((field) => entries.some((entry) => entry[field.key] !== null && entry[field.key] !== undefined && entry[field.key] !== ""));
  if (!available.length) return null;
  return (
    <div className="grid gap-3 rounded-2xl border border-neutral-200 bg-neutral-50 p-4 sm:grid-cols-2 lg:grid-cols-3" aria-label="Chart filters">
      {available.slice(0, 6).map((field) => {
        const values = [...new Set(entries.map((entry) => entry[field.key]).filter((value) => value !== null && value !== undefined && value !== "").map(String))].sort();
        return (
          <label key={field.key} className="text-xs font-black uppercase tracking-[0.12em] text-neutral-600">
            {field.label}
            <select value={filters[field.key] || ""} onChange={(event) => onChange(field.key, event.target.value)} className="mt-2 w-full rounded-xl border border-neutral-300 bg-white px-3 py-2 text-sm font-semibold normal-case tracking-normal text-neutral-900">
              <option value="">All</option>
              {values.map((value) => <option key={value} value={value}>{value === "true" ? "Yes" : value === "false" ? "No" : value}</option>)}
            </select>
          </label>
        );
      })}
    </div>
  );
}
